<template>
    <div class="messcenter">
 <el-table
    :data="tableData"
    style="width: 100%"
    :default-sort = "{prop: 'date', order: 'descending'}"
    >
    <el-table-column
      prop="date"
      label="日期"
      sortable
    >
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
  
    >
    </el-table-column>
    <el-table-column
      prop="address"
      label="地址"
      >
    </el-table-column>
  </el-table>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }]
        };
    },
    computed: {

    },
    created() {

    },
    methods: {

    },
};
</script>

<style  lang="less">
.messcenter{

}
</style>



// WEBPACK FOOTER //
// src/components/assessment/messcenter.vue